<template>
  <div>
    <div id="container">
      <i class="fa fa-spinner spin fa-2x text-white" v-if="waiting"></i>
      <iframe :src="src" v-if="!waiting"></iframe>
    </div>
  </div>
</template>
<script>
export default {
  name: 'pdfPreview',
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      src: null,
      waiting: false
    }
  },
  created() {
    this.fetchPdfFile()
  },
  methods: {
    fetchPdfFile() {
      this.src = null
      this.waiting = true
      this.$store
        .dispatch('paymentTesting/printPdf', this.id)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  },
  watch: {
    id: function(id) {
      if (id) {
        this.fetchPdfFile()
      }
    }
  }
}
</script>
<style scoped>
#container {
  width: 100%;
  height: 635px;
  background: black;
  text-align: center;
}
#container iframe {
  width: 100%;
  height: 635px;
  border: 2px solid #acacac;
}
#container i {
  margin-top: 32vh;
}
</style>
